import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState } from '@/store'
import { makeStyles } from 'tss-react/mui'
import { useForm } from 'react-hook-form'
import { setCity } from '@/slices/user'
import { StepContent } from './StepContent'
import { CreatorButtons } from './CreatorButtons'
import { CreatorSteps, markStepCompletedByName, nextStep } from '@/slices/creator'
import { City as CityEnum } from '@namuho/types'
import { RadioInput } from '../common/RadioInput'

const useStyles = makeStyles()((theme) => ({
    root: {
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
    },
    wrapper: {
        maxWidth: 400,
    },
}))

export interface CityForm {
    city: CityEnum
}

export const City = () => {
    const { register, getValues, setValue } = useForm<CityForm>()
    const user = useSelector((state: RootState) => state.createdUser)
    const { classes } = useStyles()
    const dispatch = useDispatch()

    const handleNext = () => {
        const city = getValues('city')
        dispatch(setCity(city))
        dispatch(markStepCompletedByName(CreatorSteps.CITY))
        dispatch(nextStep())
    }

    useEffect(() => {
        if (user.city) {
            setValue('city', user.city)
        }
    }, [setValue, user.city])

    return (
        <StepContent
            content={
                <form className={classes.root}>
                    <RadioInput
                        centered
                        label="In welcher Stadt soll dein Date/Treffen stattfinden?"
                        options={Object.values(CityEnum).map((city) => ({
                            label: city,
                            value: city,
                        }))}
                        {...register('city')}
                    />
                </form>
            }
            buttons={
                <CreatorButtons
                    nextStepActive={true}
                    previousStepActive={false}
                    isFirst={true}
                    isLast={false}
                    skipActive={false}
                    handleNext={handleNext}
                />
            }
        />
    )
}
